// extracted by mini-css-extract-plugin
export default {"input":"zp6yGYc2"};